module.exports = __webpack_public_path__ + "img/OpenSans-BoldItalic.abd80177.svg";